module.exports = __webpack_public_path__ + "static/media/WebsiteTitle.11891f19.png";